export const NEWLY_INSTALLED = "Installed less than 8 days ago";
